export const SHOPIFY_URL = "https://lauracombsproductions.myshopify.com/";
export const SHOPIFY_BOOKS = SHOPIFY_URL + "collections/books";
// TODO: confirm exact Downloads/digital-products collection URL with the user, then update below.
export const SHOPIFY_DOWNLOADS = SHOPIFY_URL;

export const SITE_URL = "https://lauracombsproductions.com";
export const SITE_NAME = "Laura Combs Productions";
export const OG_IMAGE = SITE_URL + "/brand/og-image.jpg";
